export function UserBigIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="1.5"
        width="4"
        height="4"
        rx="2"
        stroke="currentColor"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 7.28571H8C9.10457 7.28571 10 8.18114 10 9.28571V10C10 10.2761 9.77614 10.5 9.5 10.5H2.5C2.22386 10.5 2 10.2761 2 10V9.28571C2 8.18114 2.89543 7.28571 4 7.28571Z"
        stroke="currentColor"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
